import { Badge, Box, CloseButton, Drawer, Flex, Stack } from '@mantine/core'
import { FC } from 'react'
import { Title } from '../../components'
import drawerClasses from './Drawer.module.css'
import { ChatInputBox, HelpOptions } from './components'

export const HelpSideBar: FC<{ toggle: () => void; opened: boolean }> = ({
  opened,
  toggle,
}) => {
  return (
    <Drawer
      offset={0}
      opened={opened}
      onClose={toggle}
      position='right'
      classNames={drawerClasses}
      withCloseButton={false}
    >
      <Flex direction='column' h='100%'>
        {/* Header */}
        <Flex justify='space-between' pt='md'>
          <Title
            order={2}
            className='!font-semibold bg-gradient-to-r from-[#2167E4] to-[#4FAC79] text-transparent bg-clip-text'
          >
            How Can We <br />
            Help You Today?
          </Title>
          <CloseButton onClick={toggle} />
        </Flex>

        {/* Scrollable main content */}
        <Box style={{ flex: 1, overflowY: 'auto' }} mt='sm'>
          <Stack>
            <Box h='200px' bg='gray.2' />
            <Box h='200px' bg='gray.3' />
            <Box h='200px' bg='gray.4' />
            <Box h='200px' bg='gray.5' />
            <Box h='200px' bg='gray.6' />
          </Stack>
        </Box>

        {/* Horizontally scrollable badge section */}
        <Box
          py='sm'
          style={{
            overflowX: 'auto',
          }}
        >
          <Box
            style={{
              display: 'flex',
              gap: '8px',
              flexWrap: 'nowrap',
              width: 'max-content',
            }}
          >
            <Badge p='sm' variant='outline'>
              Upcoming Payout
            </Badge>
            <Badge p='sm' variant='outline'>
              Occupancy Rate
            </Badge>
            <Badge p='sm' variant='outline'>
              Partment Fee
            </Badge>
            <Badge p='sm' variant='outline'>
              Revenue Report
            </Badge>
            <Badge p='sm' variant='outline'>
              Maintenance Alerts
            </Badge>
            <Badge p='sm' variant='outline'>
              New Bookings
            </Badge>
            <Badge p='sm' variant='outline'>
              Late Fees
            </Badge>
            <Badge p='sm' variant='outline'>
              Refunds
            </Badge>
          </Box>
        </Box>
        <ChatInputBox />
        <HelpOptions />
      </Flex>
    </Drawer>
  )
}
